module.exports = __webpack_public_path__ + "e17.no2.12c7dba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e17.no2.jpg
// module id = 9B6d
// module chunks = 0